// Códigos de descuento — edición y baja con el nombre de quien lo hace (el login del local es
// compartido). El alta y la grilla siguen con su `fetch` propio en la página y la tabla.

import { get, put, delConCuerpo } from './apiClient';

const ruta = (code) => `discountCode/${encodeURIComponent(code)}`;

// → { code: { ...fila, products: [códigos] }, history: [{ action, changed_by, changed_by_name, changed_at, before_json, after_json }] }
export const detalleParaEditar = (code) => get(`${ruta(code)}/edicion`);

export const editar = (code, campos, responsable) => put(ruta(code), { ...campos, responsable });

export const darDeBaja = (code, responsable) => delConCuerpo(ruta(code), { responsable });

// La fecha de un DATETIME para el <input type="date">: los dígitos tal cual (la DB guarda hora de
// pared y Sequelize la etiqueta UTC; pasarla por `new Date()` la correría).
export function fechaParaInput(value) {
    const m = /^(\d{4}-\d{2}-\d{2})/.exec(String(value || ''));
    return m ? m[1] : '';
}

// La misma fecha para leer en la grilla: dd/mm/aaaa, o vacío si no tiene (vigencia abierta).
export function fechaCorta(value) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
}

const ETIQUETAS_TIPO = { 1: 'Estándar', 2: '3 x 2', 3: 'Por medio de pago' };
export const etiquetaTipo = (type) => ETIQUETAS_TIPO[Number(type)] || String(type);

const ACCIONES = { alta: 'Alta', edicion: 'Edición', baja: 'Baja' };
export const etiquetaAccion = (action) => ACCIONES[action] || action;

// Qué cambió en una edición, en una línea legible ("Descuento: 10 → 25 · Productos: 1 → 2").
const CAMPOS = [
    ['discount', 'Descuento', (v) => `${v}%`],
    ['from', 'Desde', fechaParaInput],
    ['to', 'Hasta', fechaParaInput],
    ['any', 'Aplica a todos', (v) => (Number(v) === 1 ? 'Sí' : 'No')],
    ['max_amount', 'Descuento máximo', (v) => `$${v || 0}`],
    ['single_use', 'Uso único', (v) => (Number(v) === 1 ? 'Sí' : 'No')],
];

function parse(json) {
    try { return json ? JSON.parse(json) : null; } catch (e) { return null; }
}

export function resumenDelCambio(entry) {
    const antes = parse(entry.before_json);
    const despues = parse(entry.after_json);
    if (!antes || !despues) return '';
    const partes = [];
    CAMPOS.forEach(([campo, etiqueta, fmt]) => {
        const a = fmt(antes[campo] == null ? '' : antes[campo]);
        const d = fmt(despues[campo] == null ? '' : despues[campo]);
        if (a !== d) partes.push(`${etiqueta}: ${a || '—'} → ${d || '—'}`);
    });
    const pa = (antes.products || []).join(',');
    const pd = (despues.products || []).join(',');
    if (pa !== pd) partes.push(`Productos: ${(antes.products || []).length} → ${(despues.products || []).length}`);
    return partes.length ? partes.join(' · ') : 'Sin cambios';
}
